module.exports = __webpack_public_path__ + "static/media/hepsiburada-logo.c6e794ca.png";